import * as Yup from "yup";

export const formValidationSchema = () =>
  Yup.object().shape({
    namaSumberPengadaan: Yup.string().required("Masukan nama sumber pengadaan"),
  });
